import { Avatar, Box, Button, Fade, FormControl, Paper, Typography } from "@material-ui/core";
import React, { useEffect, useState } from "react";

import { BlankModel } from "../Models/BlankModel";
import { BlankViewModel } from "../ViewModels";
import { Centered } from "../Components";
import { EditableInput } from "../Components";

export const BlankPage: React.FunctionComponent = () => {
    const [viewModel] = useState(() => new BlankViewModel());

    //useEffect below only gets run on initial render
    useEffect(() => {
        // *optional* passing the router into the viewmodel so we can navigate from there
        console.log("First render");
        //This gets run when the page is exited
        return () => {
            console.log("Unmounting");
        };
    }, []);

    return (
        <Centered>
            <Fade in timeout={1000}>
                <Paper>
                    <Box padding="5px">
                        <form onSubmit={viewModel.doSubmit}>
                            {viewModel.errorMessage !== "" && (
                                <Typography variant="caption" style={{ color: "red" }}>
                                    {viewModel.errorMessage}
                                </Typography>
                            )}
                            {/*Here we are using the *optional* generic type of the model to give us intellisense on the fieldname*/}
                            <EditableInput<BlankModel> type="email" label="Email Address" validateOnBlur={true} viewModel={viewModel} fieldName="firstName" />
                            <Button type="submit" fullWidth variant="contained" color="primary">
                                {viewModel.IsLoading ? "Please Wait..." : "Sign In"}
                            </Button>
                        </form>
                    </Box>
                </Paper>
            </Fade>
        </Centered>
    );
};
